<template>
  <div class="notice_release">
    <template v-if="!flag">
      <header>
        <p>通知公告</p>
        <el-button v-if="showBtn" type="primary" style="width:100px" @click="release">发布通知</el-button>
      </header>
      <main>
        <div class="notice_box" v-for="(item,index) in list" :key="index">
          <div
            class="left"
            :style="{cursor:showBtn?'auto':'pointer'}"
            @click="mvoeDetail(item,'content')"
          >
            <p class="create_time">
              <img src="./img/time.png" alt />
              <span>{{formatTime(item.createDate)}}</span>
            </p>
            <p class="content">{{item.title}}</p>
          </div>
          <div class="right" v-if="showBtn">
            <el-button type="text" style="color:#199AFF" @click="mvoeDetail(item)">查看</el-button>
            <el-button type="text" style="color:#1CC28C" @click="updates(item)">编辑</el-button>
            <el-button type="text" style="color:#FD6666" @click="deletes(item.id)">删除</el-button>
          </div>
        </div>
      </main>
      <el-pagination
        v-if="list.length > 0"
        style="text-align:center;margin:20px 0 0 0"
        :page-sizes="pageSizeList"
        :page-size="pageSize"
        @size-change="$event=>sizeChange($event,this.getList)"
        @current-change="$event=>numberChange($event,this.getList)"
        :current-page.sync="pageNo"
        background
        layout="prev, pager, next,sizes"
        :total="total"
      ></el-pagination>
      <el-dialog
        :lock-scroll="false"
        :append-to-body="true"
        center
        :close-on-click-modal="false"
        :title="title"
        @close="closeModal"
        :visible.sync="centerDialogVisible"
        width="590px"
      >
        <el-form ref="form" :model="query" :rules="rules" label-width="100px">
          <el-form-item prop="title" label="通知标题">
            <el-input
              maxlength="50"
              style="width:400px"
              v-model="query.title"
              placeholder="请输入通知标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="通知内容" prop="content">
            <el-input
              style="width:400px;"
              type="textarea"
              height="450px"
              :autosize="{ minRows: 10, maxRows: 20}"
              placeholder="请输入内容"
              v-model="query.content"
            ></el-input>
          </el-form-item>
          <el-form-item prop="pdf" label=" ">
            <el-upload
              :before-upload="handleUpload"
              :on-error="handleError"
              :on-remove="handleRemove"
              :on-success="uploadSuccess"
              :data="{token: uptoken}"
              :file-list="fileList"
              accept=".pdf, .PDF"
              action="//up-z1.qiniup.com"
            >
              <el-button type="primary" icon="el-icon-upload">上传pdf文件</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            :loading="submitLoading"
            style="width:90px;margin-right:40px"
            type="primary"
            @click="handleSubmit"
          >确 定</el-button>
          <el-button style="width:90px;" @click="handleCancel">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        center
        :close-on-click-modal="false"
        title="删除"
        width="600px"
        :visible.sync="deleteModal"
      >
        <p style="font-size:18px;text-align:center;padding:20px">删除之后数据将不可恢复，是否继续？</p>
        <span slot="footer" class="dialog-footer">
          <el-button style="width:90px;margin-right:40px" type="primary" @click="handleDelete">确 定</el-button>
          <el-button style="width:90px;" @click="deleteModal = false">取 消</el-button>
        </span>
      </el-dialog>
    </template>
    <noticeDetails @hideDetail="hideDetail" :detailInfo="detailInfo" v-else></noticeDetails>
  </div>
</template>
<script>
import {
  addNotice,
  updateNotice,
  noticeDetail,
  noticeList,
  deleteNotice
} from "@/api/sports-management";
import noticeDetails from "./components/notice-details";
import { getUploadToken } from "@/api/upload.js";
import { page, message, dialog } from "@/common/js/mixins";
import { method } from "@/utils/utils";
import { getSession } from "@/utils/storage";
export default {
  mixins: [page, message, dialog],
  components: {
    noticeDetails
  },
  data() {
    return {
      userInfo: JSON.parse(getSession("userInfo")),
      list: [],
      fileList: [],
      uptoken: "",
      flag: false,
      submitLoading: false,
      operationId: null,
      detailInfo: {},
      query: {
        title: "",
        content: "",
        pdf: "",
        pdfName: ""
      },
      rules: {
        title: [
          {
            required: true,
            message: "通知标题不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    },
    showBtn() {
      return this.userInfo.type === 3 ? true : false;
    }
  },
  methods: {
    // 详情返回
    hideDetail() {
      this.flag = false;
      this.detailInfo = {};
    },
    // 查看详情
    mvoeDetail(data, content = null) {
      if (content && this.showBtn) {
        return;
      }
      this.detailInfo = data;
      this.flag = true;
    },
    // 打开修改弹窗
    updates(data) {
      this.operationId = data.id;
      this.openDialog("修改通知");
      this.$nextTick(() => {
        for (let item in data) {
          if (this.query.hasOwnProperty(item)) {
            this.$set(this.query, item, data[item]);
          }
        }
        if (data.pdf && data.pdfUrl) {
          this.fileList = [{ name: data.pdfName }];
        }
      });
    },
    // 删除
    handleDelete() {
      deleteNotice({
        id: this.operationId
      })
        .then(res => {
          this.openSuccess("删除成功！");
          this.closeDeleteDialog();
          this.getList();
        })
        .catch(err => {});
    },
    // 打开删除弹窗
    deletes(id) {
      this.operationId = id;
      this.openDeleteDialog();
    },
    // 打开通知发布弹窗
    release() {
      this.openDialog("通知发布");
    },
    // 上传成功
    uploadSuccess(data, file, fileList) {
      this.fileList = [file];
      Object.assign(this.query, {
        pdf: data.key,
        pdfName: file.name
      });
      this.openSuccess("上传成功!");
    },
    // 移除已上传文件
    handleRemove(file) {
      this.fileList = [];
      Object.assign(this.query, {
        pdf: "",
        pdfName: ""
      });
    },
    // 上传文件前
    handleUpload(file) {
      let fileName = file.name.substring(file.name.lastIndexOf(".") + 1);
      let formats = fileName === "pdf" || fileName === "PDF";
      if (!formats) {
        this.openWarn("上传文件只能是pdf格式");
      }
      return formats;
    },
    // 上传失败
    handleError(error) {
      this.openError(error);
    },
    // 弹窗关闭
    closeModal() {
      this.$refs.form.resetFields();
      this.fileList = [];
    },
    // 获取列表
    getList() {
      noticeList({ pageNo: this.pageNo, pageSize: this.pageSize })
        .then(res => {
          this.total = res.total;
          this.list = res.list;
        })
        .catch(err => {});
    },
    // 获取token
    getToken() {
      getUploadToken({
        type: 1
      })
        .then(res => {
          this.uptoken = res;
        })
        .catch(err => {});
    },
    // 通知保存
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.query.content && !this.query.pdf)
            return this.openWarn("请输入通知内容或上传pdf文件");
          this.submitLoading = true;
          if (this.title === "通知发布") {
            addNotice({
              ...this.query
            })
              .then(res => {
                this.submitLoading = false;
                this.openSuccess("添加成功！");
                this.closeDialog();
                this.getList();
              })
              .catch(err => {
                this.submitLoading = false;
              });
          } else {
            updateNotice({
              ...this.query,
              id: this.operationId
            })
              .then(res => {
                this.submitLoading = false;
                this.openSuccess("修改成功！");
                this.closeDialog();
                this.getList();
              })
              .catch(err => {
                this.submitLoading = false;
              });
          }
        }
      });
    },
    // 取消发布/修改
    handleCancel() {
      this.$refs.form.resetFields();
      this.fileList = [];
      this.closeDialog();
    }
  },
  mounted() {
    this.getToken();
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.notice_release {
  height: 100%;
  header {
    padding-bottom: 20px;
    border-bottom: 1px solid #dfdfdf;
    display: flex;
    align-items: center;
    > p {
      flex: 1;
      font-size: 18px;
      color: #222;
    }
  }
  /deep/ .el-textarea__inner {
    resize: none;
  }
  main {
    .notice_box {
      padding: 20px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #dfdfdf;
      > .left {
        flex: 1;
        margin-right: 50px;
        > .create_time {
          display: flex;
          align-items: center;
          img {
            width: 22px;
            height: 22px;
            margin-right: 10px;
          }
        }
        > .content {
          margin-top: 10px;
          font-size: 18px;
          line-height: 25px;
          color: #444;
        }
      }
      > .right {
        width: 120px;
      }
    }
  }
}
</style>